export const en = {
    dashboard: 'Dashboard',
    liveStats: "Today's Statistics",
    viewsToday: 'Views Today',
    subscription: 'Subscription',
    activity: 'Activity',
    views_count: 'views',
    until: 'until',
    hoursShort: 'h',
    unknownDish: 'Unknown dish',
    unlimited: 'Unlimited',
    expired: 'expired',
    expiringSoon: 'is expiring soon',
    extend: 'Extend',
    daysShort: 'd',
    gracePeriodActive: 'Grace period active',
    remaining: 'remaining',
    renewToKeepAccess: 'Renew to keep access',
    analyticsLocked: 'Analytics Locked',
    availableInPlans: 'Available in',
    viewTariffs: 'View Tariffs',
    and: 'and',
    marketingToolsDesc: 'Advanced marketing tools for your establishment.',
    activeBanners: 'Active Banners',
    availableInSmart: 'Available in Smart tariff',
    addVariant: 'Add variant',
    noBanners: 'No banners yet. Add them in settings.',
    tapToOpenMap: '*tap here to view in 2GIS',
    usersManagement: 'Users Management',
    logs: 'Activity Logs',
    createCafe: 'Create Cafe',
    logout: 'Logout',
    allCafes: 'Total Establishments',
    users: 'Account',
    activeMenus: 'Active Menus',
    yourCafes: 'Your Establishments',
    all: 'All',
    gridView: 'Grid',
    listView: 'List',
    manage: 'Manage',
    analytics: 'Analytics',
    openMenu: 'Open Menu',
    viewMenu: 'View Menu',
    network: 'Network',
    password: 'Password',
    tariffs: 'Subscription',
    qrCodeMenu: 'QR Code',
    messages: 'Messages',
    support: 'Support',
    account: 'Account',
    refresh: 'Refresh',
    downloadReport: 'Download report as PDF',
    outsidersDesc: 'Low traffic items',
    guestsSearchingDesc: 'What guests are looking for',
    noViewsDesc: 'Items with zero views',
    searchDishes: 'Search dishes...',
    noDishes: 'No dishes found.',
    availability: 'Available',
    stopList: 'Stop-list',
    available: 'Available',
    unavailable: 'Unavailable',
    addToCart: 'Add to Cart',
    price: 'Price',
    description: 'Description',
    nutrients: 'Nutrition',
    stickers: 'Labels',
    weight: 'Weight',
    proteins: 'Proteins',
    fats: 'Fats',
    carbs: 'Carbs',
    calories: 'Kcal',
    grams: 'g',
    ml: 'ml',
    save: 'Save',
    cancel: 'Cancel',
    editDish: 'Edit Dish',
    addDish: 'Add Dish',
    category: 'Category',
    name: 'Name',
    dishName: 'Dish Name',
    dishPrice: 'Price',
    selectCategory: 'Select Category',
    optionalInfo: 'Optional Info (Nutrition & Labels)',
    uploadImage: 'Drag image here',
    uploadHint: 'or click to select (PNG, JPG up to 5MB)',
    activeIconTitle: 'Available dishes',
    stopListIconTitle: 'Dishes in stop-list',
    globalStopList: 'Global Stop-list',
    returnToAvailability: 'Return to Availability',
    stats24h: 'Views last 24h',
    topDish: 'Popular Dish',
    lastChanges: 'Last Changes',
    topDishesWidget: 'Top Dishes',
    cafesLabel: 'Cafes',
    nothingFoundHeader: 'Whoops!',
    nothingFoundText: 'Nothing found for your search. Try another query.',
    clearSearch: 'Clear search',
    // New ones
    energyValueLabel: 'Energy value',
    noDescription: 'No description',
    downloadApp: 'Download App',
    installSuccess: 'App installed successfully!',
    pwaFallbackTitle: 'Install App',
    pwaFallbackMessage: 'To install the app, tap the browser menu (three dots) and select "Add to Home screen" or "Install app".',
    remove: 'Remove',
    receiptTitle: 'RECEIPT',
    headerQty: 'Qty',
    subtotal: 'Subtotal:',
    serviceCharge: 'Service Charge',
    totalAmount: 'TOTAL:',
    clearCart: 'Clear receipt',
    close: 'Close',
    nameHeader: 'Name',
    hidden: 'Hidden',
    drafts: 'Drafts',
    basicInfo: 'Basic Info',
    variants: 'Variants',
    regularPrice: 'Regular Price',
    addVariants: 'Add Variants',
    sizes: 'Sizes',
    typesWithPhoto: 'Types (with photo)',
    optional: 'Optional',
    bannerManagement: 'Banner Management',
    addNewBanner: 'Add New Banner',
    titleOptional: 'Title (optional)',
    bannerImage: 'Banner Image',
    recommendedSize: '2:1 recommended',
    saveChanges: 'Save Changes',
    noTitle: 'No Title',
    confirmation: 'Confirmation',
    areYouSure: 'Are you sure?',
    yesDelete: 'Yes, delete',
    loading: 'Loading...',
    processing: 'Processing...',
    dbError: 'DB Error',
    tryAgain: 'Try Again',
    systemOnline: 'System: Online',
    systemOffline: 'System: Offline',
    database: 'Database',
    storage: 'Files (Storage)',
    active: 'Active',
    hiddenStatus: 'Hidden',
    edit: 'Edit',
    delete: 'Delete',
    categoryManagement: 'Category Management',
    categoryDescriptionPlaceholder: 'Description (message to guests)',
    sections: 'Sections',
    newCategoryPlaceholder: 'New category name (e.g. Drinks)',
    add: 'Add',
    show: 'Show',
    hide: 'Hide',
    categoriesEmpty: 'Category list is empty.',
    settings: 'Settings',
    basicSettings: 'Basic Settings',
    cafeName: 'Establishment Name',
    address: 'Address',
    servicePercent: 'Service Charge (%)',
    maintenanceMode: 'Maintenance Mode',
    maintenanceDesc: 'Hides menu from guests',
    saveSettings: 'Save Settings',
    profileData: 'Profile Data',
    firstName: 'First Name',
    lastName: 'Last Name',
    emailCannotBeChanged: 'Email cannot be changed',
    updateProfile: 'Update Profile',
    security: 'Security',
    newPassword: 'New Password',
    minChars: 'Min 6 characters',
    confirmPassword: 'Confirm Password',
    changePassword: 'Change Password',
    passwordsDoNotMatch: 'Passwords do not match',
    passwordTooShort: 'Password must be at least 6 characters',
    passwordChangedSuccess: 'Password changed successfully',
    profileUpdated: 'Profile updated',
    maritalsSuccess: 'Profile updated', // Just in case
    menuByCategories: 'Menu by Categories',
    quickDishSearch: 'Quick dish search...',
    clickToChange: 'Click to change',
    editPhoto: 'Edit',
    changePhoto: 'Change',
    publishedDraft: 'PUBLISHED (DRAFT)',
    saveDraft: 'Save Draft',
    dishDeleted: 'Dish deleted',
    additional: 'Additional',
    welcomeAdmin: 'Welcome to Admin Panel!',
    noCafeMessage: 'It seems no cafe is assigned to your account yet. Please contact platform administrator.',
    categoryDeleteWarning: 'In category',
    dishes: 'dishes',
    deleteCategoryWarning: 'If you delete it, these dishes will remain "uncategorized".',
    deleteCategoryConfirm: 'Are you sure you want to delete category',
    categoryAdded: 'Category added!',
    dishAdded: 'Dish added successfully!',
    dishDuplicated: 'Dish duplicated!',
    saved: 'Changes saved',
    categoryDeleted: 'Category deleted',
    language: 'Language',
    lightTheme: 'Light Theme',
    darkTheme: 'Dark Theme',
    categoryExists: 'This category already exists!',
    categoryUpdated: 'Category updated',
    manageSections: 'Manage Sections',
    visible: 'Visible',
    hiddenMsg: 'Hidden',
    uploadError: 'Photo upload error',
    saveError: 'Save error',
    updateError: 'Update error',
    deleteError: 'Delete error',
    accessError: 'Access error',
    syncError: 'Sync error',
    networkError: 'Network error',
    uncategorized: 'Uncategorized',
    cafeNotFound: 'Cafe not found or link is invalid.',
    backToHome: 'Back to Home',
    loadingError: 'An error occurred while loading the menu.',
    maintenanceTitle: 'Maintenance',
    maintenanceText: "We'll be back soon!",
    temporarilyClosed: 'Closed soon',
    menuSuspendedTitle: 'Menu Temporarily Unavailable',
    menuSuspendedText: 'Establishment suspended the online menu. Please contact staff.',
    error: 'Error',
    attention: 'Attention',
    thisCategory: 'this category',
    owner: 'Owner',
    notSpecified: 'Not specified',
    errorSendingRequest: 'Error sending request',
    dishLimitReached: 'Dish limit for plan %plan% reached (%limit%). Upgrade to Smart for unlimited.',
    ageRestriction: 'Age Restriction (21+)',
    ageGateTitle: 'Alcoholic Drinks 21+',
    ageGateMessage: 'To view this category, confirm that you are at least 21 years old.',
    ageGateConfirm: 'Confirm',
    passwordRuleLength: 'Use at least 6 characters',
    passwordRuleUpper: "Don't forget uppercase letter",
    passwordRuleNumber: 'Add at least one number',
    passwordRuleLatin: 'Latin characters only',
    passwordRuleMatch: 'Passwords match',
    currentPassword: 'Current Password',
    enterPassword: 'Enter password',
    enterNewPassword: 'Enter new password',
    incorrectPassword: 'Incorrect current password',
    modifiers: 'Modifiers / Ingredients',
    modifierName: 'Name (e.g. Cheese)',
    noModifiers: 'No modifiers',
    addModifier: 'Add modifier',
    from: 'from ',
    pricePlus: 'Price (+)',
    tabNutrition: 'Tags & Nutrition',
    selectedTags: 'Selected',
    wineCountry: 'Country',
    whiskeyType: 'Spirits',
    allSections: 'All Sections',
    mandatory: 'MANDATORY',
    multipleChoice: 'MULTIPLE CHOICE',
    variantNamePlaceholder: 'Name (e.g. Strawberry)',
    variantSizePlaceholder: 'Name (e.g. 30 cm)',
    dishImage: 'Dish Image',
    saveAsDraft: 'Save as Draft',
    timeRestriction: 'Time Restriction',
    timeRestrictionHint: 'Category and its dishes will only be shown to guests during the specified hours and days',
    availableFrom: 'From',
    availableTo: 'To',
    scheduleDays: 'Active Days',
    allDays: 'All Days',
    day_1: 'Mon',
    day_2: 'Tue',
    day_3: 'Wed',
    day_4: 'Thu',
    day_5: 'Fri',
    day_6: 'Sat',
    day_7: 'Sun',
    scheduleActive: 'Active Now',
    scheduleInactive: 'Unavailable Now',
    onlyAvailableTime: 'Available from %from% to %to%',
    // Login Page
    loginTitle: 'QR-table',
    loginSubtitle: 'Manage your establishment easily and efficiently.',
    loginTab: 'Login',
    registerTab: 'Register',
    emailLabel: 'Email',
    passwordLabel: 'Password',
    emailPlaceholder: 'your@email.com',
    passwordPlaceholder: '••••••••',
    signInButton: 'Sign In',
    signingInButton: 'Signing In...',
    forgotPassword: 'Forgot password?',
    resetPasswordEmailSent: 'Password reset link has been sent to your email',
    resetPasswordSuccess: 'Password has been reset successfully',
    loginLockout: 'Too many attempts. Please try again in 2 minutes.',
    userNotFound: 'User not found',
    registerInfoTitle: 'Registration',
    registerInfoText: 'Please contact support to create an account.',
    backToLogin: 'Back to Login',
    empowerTitle: 'Empower Your Business',
    empowerDescription: 'Full control over your digital menu. Track views, manage dishes, and grow your revenue in real-time.',
    chefQuote1: '"To become a great chef, you have to work with great chefs. And that\'s exactly what I did." — Gordon Ramsay',
    chefQuote2: '"Your body is not a temple, it\'s an amusement park. Enjoy the ride." — Anthony Bourdain',
    chefQuote3: '"Food is a way of communication. Through it we share emotions and culture." — Massimo Bottura',
    chefQuote4: '"A recipe has no soul. You, as the cook, must bring soul to the recipe." — Thomas Keller',
    chefQuote5: '"Cooking is not a science. It\'s an art that requires patience and passion." — Wolfgang Puck',
    chefQuote6: '"Good food is very often, even most often, simple food." — Anthony Bourdain',
    chefQuote7: '"If you\'re afraid of butter, use cream." — Julia Child',
    chefQuote8: '"We eat with our eyes first, and everything else second." — Paul Bocuse',
    chefQuote9: '"The kitchen is where memories are born." — Alain Ducasse',
    chefQuote10: '"I don\'t cook food. I cook experiences." — Heston Blumenthal',
    chefQuotesTitle: "Chef's Wisdom",
    bannersLabel: 'Banners',
    chooseOne: 'Choose one',
    chooseMultiple: 'Choose multiple',
    pleaseSelect: 'Please select',
    min: 'min',
    max: 'max',
    withPercent: '*incl. service',
    // Lead Form
    yourName: 'Your Name',
    yourPhone: 'Phone Number',
    yourCafeName: 'Cafe Name',
    sendRequest: 'Send Request',
    requestSentTitle: 'Request Sent',
    requestSentMessage: 'We will contact you shortly!',
    fillAllFields: 'Please fill all fields',
    yourTelegram: 'Your Telegram (@username)',
    sauces: 'Sauces',
    spiciness: 'Spiciness',
    sugarLevel: 'Sugar Level',
    roastingLevel: 'Roasting Level',
    ice: 'Ice',
    toppings: 'Toppings',
    milk: 'Milk',
    syrup: 'Syrup',
    sideDish: 'Side Dish',
    dressing: 'Dressing',
    bread: 'Bread',
    exclude: 'Exclude',
    size: 'Size',
    volume: 'Volume',
    temperature: 'Temperature',
    sugar: 'Sugar',
    dough: 'Dough',
    addIngredients: 'Add ingredients',
    excludeIngredients: 'Exclude ingredients',
    autoTranslate: 'Auto-translate',
    autoTranslateCategory: 'Translate whole category',
    linkPlaceholder: 'Link (https://...)',
    confirmAutoTranslate: 'Are you sure you want to start auto-translation? Empty fields will be filled automatically.',
    // Common Types
    withChicken: 'With chicken',
    withShrimp: 'With shrimp',
    withBeef: 'With beef',
    withSalmon: 'With salmon',
    withPork: 'With pork',
    withVegetables: 'With vegetables',
    classic: 'Classic',
    withCheese: 'With cheese',
    // Portions
    smallPortion: 'Small',
    mediumPortion: 'Medium',
    largePortion: 'Large',
    // Common Ingredients
    extraMeat: 'Add meat',
    extraCheese: 'Add cheese',
    mushrooms: 'Mushrooms',
    bacon: 'Bacon',
    egg: 'Egg',
    // Exclusions
    withoutOnion: 'No onion',
    sugarFree: 'Sugar free',
    lactoseFree: 'Lactose free',
    glutenFree: 'Gluten free',
    // Preparation
    grilled: 'Grilled',
    steamed: 'Steamed',
    baked: 'Baked',
    // Temp
    hot: 'Hot',
    cold: 'Cold',
    // Common Categories
    catCombo: 'Combo',
    catSalads: 'Salads',
    catAppetizers: 'Appetizers',
    catBurgers: 'Burgers',
    catBurgersAndDoners: 'Burgers and Doners',
    catPizza: 'Pizza',
    catDrinks: 'Drinks',
    catDesserts: 'Desserts',
    catBreakfast: 'Breakfast',
    catLunch: 'Lunch',
    catMainCourses: 'Main Courses',
    catSoups: 'Soups',
    catSteaks: 'Steaks',
    catCocktails: 'Cocktails',
    catTeaCoffee: 'Tea & Coffee',
    catAlcohol: 'Alcohol',
    catSides: 'Sides',
    catPasta: 'Pasta',
    catFishAndSeafood: 'Fish and Seafood',
    catHotDishes: 'Hot Dishes',
    catKidsMenu: 'Kids Menu',
    catPastries: 'Pastries',
    catBakeryAndBread: 'Bakery and Bread',
    catColdDrinks: 'Cold Drinks',
    catHotDrinks: 'Hot Drinks',
    catStreetFood: 'Street Food',
    catHotAppetizers: 'Hot Appetizers',
    catColdAppetizers: 'Cold Appetizers',
    catBar: 'Bar',
    catAlcoholicDrinks: 'Alcoholic Drinks',
    catPastaAndRisotto: 'Pasta and Risotto',
    catSushiRolls: 'Sushi Rolls',
    catNoodles: 'Noodles',
    catFitnessMenu: 'Fitness Menu',
    catGrill: 'Grill & BBQ',
    catBeerSnacks: 'Beer Snacks',
    catWineList: 'Wine List',
    catSpirits: 'Spirits',
    catSoftDrinks: 'Soft Drinks',
    catLemonades: 'Lemonades & Smoothies',
    catPlatters: 'Platters & Sets',
    catSeasonal: 'Seasonal Menu',
    catVegan: 'Vegan Menu',
    catHookah: 'Hookah',
    catOriental: 'Oriental Cuisine',
    catPanAsian: 'Pan-Asian Cuisine',
    catGeorgian: 'Georgian Cuisine',
    catEuropean: 'European Cuisine',
    takeAway: 'Take away',
    dineIn: 'Dine-in',
    noGarlic: 'No garlic',
    noHerbs: 'No herbs',
    extraSauce: 'Extra sauce',
    confirmDelete: 'Delete Dish',
    confirmDeleteMessage: 'Are you sure you want to delete dish',
    copy: 'Copy',
    tariffPlansTitle: 'Tariff Plans',
    tariffPlansSubtitle: 'Choose the right set of tools for your business',
    planDescSmart: 'Popular',
    planDescBusiness: 'For professionals',
    popularBadge: 'Popular',
    currentPlanLabel: 'Your current plan',
    connectBtn: 'Connect',
    helpWithChoice: 'Need help choosing?',
    contactUs: 'Contact us',
    perMonth: '/ mo',
    featureUnlimitedDishes: 'Unlimited number of dishes',
    featureMultilingualAI: 'Multilingual (AI translation 100 cards limit)',
    featureModifiersVariants: 'Modifiers and variants',
    feature2GisAuto: 'Auto-upload to 2GIS',
    featureBanners: 'Banners',
    featureAllSmart: 'All Smart features',
    featureWaiterPanel: 'Waiter Panel',
    featureTgBotWaiter: 'Telegram bot integration for waiter',
    featureAiWaiterChoice: 'AI Waiter helps guests choose dishes',
    featureDataEntry: 'Full setup for up to 100 dishes',
    featureSubdomain: 'Custom subdomain (name-cafe.qr-table.kz)',
    featureMultilingual: 'Multilingual support',
    featureModifiers: 'Modifiers',
    feature2Gis: '2GIS integration',
    upgradeBtn: 'Upgrade plan',
    downgradeBtn: 'Downgrade plan',
    translationError: 'Translation error. Check balance or API settings.',
    sourceTextMissing: 'Enter text in RU first.',
    duplicate: 'Duplicate',
    // Messages Component
    noDialogs: 'No dialogs',
    selectDialog: 'Select a dialog on the left',
    writeMessagePlaceholder: 'Write a message...',
    ticketInfo: 'Ticket',
    screenshotLink: 'Screenshot',
    statusNew: 'New',
    statusInProgress: 'In Progress',
    statusResolved: 'Resolved',
    statusClosed: 'Closed',
    problemDesc: 'Problem Description:',
    // QR Code Generator
    qrCodeMenuTitle: 'QR Code Menu',
    preview: 'Preview',
    downloadPNG: 'Download PNG',
    downloadSVG: 'Download SVG',
    link: 'Link',
    qrLinkHelp: 'Guests will open this link by scanning the QR code.',
    appearance: 'Appearance',
    patternColor: 'Pattern Color',
    backgroundColor: 'Background Color',
    establishmentLogo: 'Establishment Logo',
    currentLogo: 'Current Logo',
    replaceFile: 'Replace File',
    logoNotSelected: 'Logo not selected',
    upload: 'Upload',
    fileTooBig: 'File is too big! Max size 2MB',
    uploadImageError: 'Please upload an image (PNG, JPG)',
    linkCopied: 'Link copied!',
    errorSavingQR: 'Failed to save settings',
    errorUploadingLogo: 'Error uploading logo: ',
    // Support Modal
    contactSupport: 'Contact Support',
    topic: 'Topic',
    topicBilling: 'Subscription Issue / Payment',
    topicTech: 'Technical Error',
    topicFeature: 'Feature Request',
    topicQR: 'QR Codes & Printing Question',
    topicOther: 'Other',
    ticketSubject: 'Subject (briefly)',
    ticketSubjectPlaceholder: 'E.g., Translation not working',
    ticketDesc: 'Description',
    ticketDescPlaceholder: 'Describe in detail what happened...',
    screenshot: 'Screenshot or file (optional)',
    attachFile: 'Attach File',
    changeFile: 'Change',
    sendTicket: 'Send Ticket',
    sending: 'Sending...',
    ticketSent: 'Ticket Sent!',
    ticketSentDesc: 'We have received your message and will reply soon.',
    // Contact Us Modal
    contactTitle: 'Contact Us',
    contactSubtitle: 'For tariff and partnership inquiries',
    selectPlan: 'Select Plan',
    iWantToConnect: 'I want to connect:',
    currentPlan: 'Current Plan:',
    message: 'Message',
    messagePlaceholder: 'E.g., I want to upgrade to Business plan',
    contactSuccess: 'Request Sent!',
    contactSuccessDesc: 'We will contact you shortly.',
    // Analytics
    missedRevenue: 'Missed Revenue',
    missedClicks: 'Clicks on "Stop List"',
    wantedToOrder: 'WANTED TO ORDER',
    searchInsights: 'Search Insights',
    notFound: 'not found',
    found: 'found',
    clicks: 'clicks',
    totalViews: 'Total Views',
    totalVisitors: 'Unique Visitors',
    uniqueVisitors: 'Unique Visitors',
    totalMenuOpens: 'Total Menu Opens',
    topDishes: 'Top Dishes',
    popularity: 'popularity',
    stickerEfficiency: 'Banner/Sticker Efficiency',
    noStickerData: 'No sticker data',
    preferences: 'Preferences',
    activityOverTime: 'Activity Over Time',
    overview: 'Overview',
    menuAnalysis: 'Menu Analysis',
    visualGraphics: 'Visual Graphics',
    estimatedLoss: 'Estimated Loss',
    clicksInStopList: 'Clicks in stop-list',
    audienceLanguage: 'Audience Language',
    menuLeaderboard: 'Menu Leaderboard',
    needsAttention: 'Needs Attention',
    whatGuestsWant: 'Guest Demand',
    hiddenGems: 'Hidden Potential',
    allDishesActive: 'All menu items are active!',
    visitorTraffic: 'Visitor Traffic',
    categoryInterest: 'Category Interest',
    noData: 'No data',
    analyticsSubtitle: 'Performance overview of your establishment',
    today: 'Today',
    yesterday: 'Yesterday',
    exportPDF: 'Export PDF',
    exporting: 'Exporting...',
    frameStyle: 'Template Style',
    selectTemplate: 'Select Template',
    downloadTemplate: 'Download Template',
    templateNone: 'No Frame',
    templateSolid: 'Solid',
    templateLabel: 'Label',
    templateSticker: 'Sticker',
    templateWhiteCard: 'White Card',
    templateDarkCard: 'Dark Card',
    logo: 'Logo',
    logoTakenFromSettings: 'Logo from basic settings is being used',
    noLogoInSettings: 'No logo uploaded in basic settings',
    uploadLogo: 'Upload logo',
    cafeDescription: 'Cafe Description',
    cafeDescriptionPlaceholder: 'Tell us a bit about your establishment...',
    socialLinks: 'Social Media',
    instagram: 'Instagram',
    whatsapp: 'WhatsApp',
    telegram: 'Telegram',
    website: 'Website',
    maintenanceConfirm: 'Are you sure you want to hide the menu from guests? All active QR codes will temporarily redirect to the maintenance page.',

    // QR Code Generator Extended
    eyes: 'Eyes',
    colors: 'Colors',
    patternStyle: 'Pattern Style',
    eyeOuterFrame: 'Eye Outer Frame',
    eyeInnerDot: 'Eye Inner Dot',
    quickPalette: 'Quick Palette',
    frameText: 'Frame Text',
    font: 'Font',
    printA4: 'Print (A4 Sheet)',
    quantityPerSheet: 'Qty per sheet',
    createA4Sheet: 'Create A4 Sheet',
    a4ReadyMessage: 'A4 layout ready for 300 DPI printing.',
    qrStyle: {
        square: 'Square',
        rounded: 'Rounded',
        dots: 'Dots',
        classy: 'Classy',
        classyRounded: 'Classy Rounded',
        extraRounded: 'Extra Rounded',
        dot: 'Dot'
    },
    qrColor: {
        pattern: 'Pattern',
        background: 'Background',
        eyeFrame: 'Eye Frame',
        eyeDot: 'Eye Dot',
        frame: 'Frame',
        text: 'Text'
    },
    // PDF Report
    strategicIntelligence: 'Strategic Intelligence',
    revenueRisk: 'Revenue Risk',
    trafficInsights: 'Traffic Insights',
    menuBalance: 'Menu Balance',
    expertTip: 'Expert Tip',
    generatedDate: 'Generated Date',
    scanMenu: 'Menu',
    analyticalReport: 'Analytical Performance Report',
    reportingPeriod: 'Reporting Period',
    topPerformingItems: 'Top Performing Items',
    attentionNeeded: 'Attention Needed',
    categories: 'Categories',
    rank: 'Rank',
    totalViewsLabel: 'Total Views',
    categoryShare: 'Share',
    // Table Management
    tableManagement: 'Table Management',
    tablesQR: 'Tables QR',
    mainQR: 'Main QR',
    generateRange: 'Auto-generate',
    tableNumber: 'Table Number',
    addTable: 'Add',
    tableExists: 'Table already exists',
    confirmDeleteTable: 'Are you sure you want to delete this table?',
    downloadQR: 'Download QR',
    enterTableCount: 'Enter number of tables (e.g. 10):',
    errorAddingTable: 'Error adding table',
    noTables: 'No tables added yet',
    addTableHint: 'Add tables so guests can order via QR code',
    deleteTable: 'Delete Table',
    tablesCount: 'tables added',
    tableNum: 'No.',
    range: 'Generate',
    directLink: 'Direct Link',
    actions: 'Actions',
    downloadAll: 'Download All (ZIP)',
    downloadAllConfirm: 'Start downloading all QR codes?',
    copyLink: 'Copy Link',
    bulkDownload: 'Bulk Download',
    bulkDownloadConfirm: 'Create one ZIP archive with all tables?',
    downloadComplete: 'ZIP archive created successfully',
    personalizeQR: 'Personalize your QR code',
    bulkGenTitle: 'Bulk Generation',
    bulkGenDesc: 'Enter the number of tables to be created automatically (from 1 to N).',
    generate: 'Create',
    tablesAdded: 'Tables added successfully',
    wifiName: 'Wi-Fi Name',
    wifiPassword: 'Wi-Fi Password',
    gallery: 'Gallery',
    addPhoto: 'Add Photo',
    orDragHere: 'or drag here',
    // AI Waiter
    aiWaiterTitle: 'AI Waiter',
    aiWaiterWelcome: 'Hello! I am your AI Waiter. What would you like to order today?',
    aiWaiterPlaceholder: 'Ask me about the menu...',
    aiWaiterError: 'Oops! I seem to have lost my train of thought. Please try asking again.',

    // Waiter Panel
    waiter_panel: 'Waiter Panel',
    dark_mode: 'Dark Mode',
    dark_mode_desc: 'Saves battery and eyes',
    notifications: 'Notifications',
    push_notifications: 'Push Notifications',
    in_browser: 'In browser',
    tg_integration: 'Telegram Integration',
    tg_integration_desc: 'Personal alerts in TG',
    link_via_bot: 'Link via bot',
    my_tables: 'My Tables',
    select_tables_desc: 'Select tables you are serving',
    tg_notifications_desc: 'Get order notifications directly in Telegram.',
    connect_telegram: 'Connect Telegram',
    unlink_telegram: 'Unlink Telegram',
    tg_connected: 'Telegram connected',
    refresh_status: 'Refresh status',
    tg_connect_hint: 'Click the blue button and send START to the bot, then click Refresh status.',
    no_tables_found: 'No tables found',
    live_feed: 'Call Feed',
    all_clear: 'All clear',
    no_calls_for_tables: 'No calls for your tables',
    no_active_calls: 'No active calls',
    table: 'Table',
    waiting: 'WAITING',
    min_short: 'min',
    accept: 'Accept',
    open_bills: 'Open Bills',
    no_bills_for_tables: 'No bills for your tables',
    no_active_bills: 'No active bills',
    back: 'Back',
    'Позвать официанта': 'Call waiter',
    'Счет (наличные)': 'Bill (cash)',
    'Счет (карта)': 'Bill (card)',
    'Дозаказ': 'Reorder',
    bill_empty: 'Bill is empty',
    add_item: 'Add Item',
    close_bill: 'Close Bill',
    close_bill_confirm: 'Are you sure you want to close this bill?',
    calls: 'Calls',
    bills: 'Bills',
    feed: 'Feed',
    orders: 'Orders',
    history: 'History',
    menu: 'Menu',
    history_empty: 'History is empty',
    bill_paid: 'Bill paid',
    notes_hint: 'Regular notes stay for 24h. Pinned stay until deleted.',
    notes_all: 'All',
    notes_global: 'Global',
    notes_tables: 'Tables',
    no_notes: 'No notes',
    new_note: 'New note',
    edit_note: 'Edit Note',
    add_note: 'Add Note',
    pin_note: 'Pin this note',
    note_text_placeholder: 'Note text...',
    post_note: 'Post Note',
    delete_note_confirm_title: 'Delete note?',
    delete_note_confirm_msg: 'This action cannot be undone.',
    pin: 'Pin',
    waiter_notes_global: 'Global',
    notes: 'Notes',
    chat_id: 'Chat ID',
    ok: 'OK',
    show_qr_to_waiter: 'Show QR to Waiter',
    scan_guest_qr: 'Scan Guest QR',
    order_found: 'Order Found',
    accept_and_save: 'Accept and Go',
    qr_code_title: 'Order QR Code',
    qr_code_desc: 'Show this code to the waiter so they can quickly accept your order.',
    addToStopList: 'Add to stop-list',
    aiChefTitle: 'AI Chef',
    order_error_title: 'Order Error',
    order_error_msg: 'Failed to send your order. Please try again or call the waiter.',
    enterTableNumber: 'Enter Table Number',
    enterTableDesc: 'Please enter your table number to place an order.',
    confirm: 'Confirm',
    comment: 'Comment',
    addComment: 'Add a comment',
    commentPlaceholder: 'Your wishes for the order...',
    sendComment: 'Send',
    commentSent: 'Comment sent!',
    orderSubmitted: 'Order submitted',
    currentOrder: 'Already ordered',
    placeOrder: 'Place Order',
    newItems: 'New items',
    totalToPay: 'Total to pay',
    confirmOrder: 'Confirm Order',
    orderConfirmationHint: 'Please come to the table to confirm order details',
    reorder: 'Reorder',
    myBill: 'My Bill',
    orderSentSuccess: 'Order sent!',
    newOrderTitle: 'New Order!',
    details: 'Details',
    totalForNew: 'Total for new',
    withService: 'Including',
    order: 'Order',
    enable_camera: 'Enable Camera',
    kcal: 'Kcal',
    with_photo: 'With photo',
    compact_view: 'Compact',
    table_number_placeholder: 'Table number',
    save_changes: 'Save Changes',
    scan_instruction: 'Scan guest QR code to receive the order',

    // Cover Quotes
    quote1: "Food is symbolic of love when words are inadequate.",
    author1: "Alan D. Wolfelt",
    quote2: "One cannot think well, love well, sleep well, if one has not dined well.",
    author2: "Virginia Woolf",
    quote3: "People who love to eat are always the best people.",
    author3: "Julia Child",
    quote4: "Cooking is all about people. Food is maybe the only universal thing that really has the power to bring everyone together.",
    author4: "Guy Fieri",

    // Stickers
    sticker_new: "NEW",
    sticker_hit: "HIT",
    sticker_spicy: "SPICY",
    sticker_vegan: "VEGAN",
    sticker_nuts: "NUTS",
    sticker_non_alcoholic: "No Alco",

    // Simple Login Page
    loginTitleText: 'Log In',
    emailOrUsername: 'Email/Username',
    showPass: 'Show',
    hidePass: 'Hide',
    signInBtn: 'Sign In',
    agreementText1: 'By continuing, you agree to the ',
    agreementText2: ' and ',
    agreementText3: '.',
    privacyPolicy: 'Privacy Policy',
    userAgreement: 'User Agreement',
    footerUserAgreement: 'User Agreement',
    footerPrivacyPolicy: 'Privacy Policy',
    footerPublicOffer: 'Public Offer',

    // Dish Form & Menu Management
    tabMain: 'Main Info',
    tabModifiers: 'Modifiers',
    tabTagsNutrition: 'Tags & Nutrition',
    hasVariantsTitle: 'Sizes, volumes',
    hasVariantsDesc: 'E.g.: 25cm (400g) / 35cm (750g), 250ml / 500ml',
    variantNameAndSize: 'Name (size / weight / volume)',
    variantPrice: 'Price',
    variantPlaceholder: 'e.g. 25 cm (400 g), 0.5 L',
    recommendedSize1to1: '1:1 recommended',
    modePhotoCard: 'With photo',
    modeList: 'List (No photo)',
    dishDescriptionPlaceholder: 'Describe ingredients, taste or presentation...',
    descriptionAndComposition: 'Description and composition',
    dishNamePlaceholder: 'E.g.: Pizza 4 Cheese or Cappuccino',
    modifiersHint: 'Add sauces, doneness levels, syrups, add-ons or side dishes',
    quickAdd: 'Quick add:',
    noModifiersYet: 'This dish has no modifiers yet. Click the button below or choose a template above.',
    groupNamePlaceholder: 'Group name (e.g. Sauces)',
    deleteGroup: 'Delete group',
    mod_optional: 'Optional',
    mod_mandatory: 'Mandatory',
    mod_multiple: 'Multiple choice',
    optionName: 'Option name',
    addOption: 'Add option',
    addGroup: 'Add group',
    dishTags: 'Dish tags',
    dishTagsHint: 'Select preset tags for wine, bar and menu or add your custom tags:',
    customTags: 'Custom',
    clickToRemove: 'Click to remove',
    popularTags: 'Popular',
    wineSugar: 'Wine',
    countryRegion: 'Country',
    otherCountry: 'Other',
    searchCountryPlaceholder: 'Search country (e.g. Italy, Georgia, Kazakhstan, Spain...)',
    addCountryCustom: '+ Add',
    whiskeyAlcohol: 'Spirits',
    customTagPlaceholder: 'Custom tag (e.g. 12 yrs, IPA, Signature)',
    addTagBtn: 'Add',
    nutritionPer100g: 'Nutrition per 100g',
    nutritionTotal: 'Nutrition (Total)',
    characteristics: 'Characteristics',
    pcs: 'pcs',
    liters: 'L',
    chooseVariant: 'Choose variant',
    removeFromStopList: 'Remove from stop-list',
    returnToMenu: 'Return to Menu',
    editCategory: 'Edit Category',
    categoryNamePlaceholder: 'E.g.: Breakfast',
    editSection: 'Edit Section',
    sectionNamePlaceholder: 'E.g.: Bar, Kitchen or Hookah',
    sectionCategories: 'Categories in this Section',
    sectionCategoriesHint: 'Select categories that should belong to this section',
    quickAddCategoryPlaceholder: 'Quickly add category to this section...',
    inThisSection: 'In this section',
    searchCategories: 'Search categories...',
    noCategoriesFound: 'No categories found',
    dishesCountShort: 'dishes',
    section: 'Section',
    ageRestrictionHint: 'For categories with alcohol or tobacco products',
    saving: 'Saving...',
    start: 'Start',
    mapLink: '2GIS Link',
    mapLinkPlaceholder: 'https://go.2gis.com/...',
    workSchedule: 'Work Schedule',
    workingHours: 'Working Hours',
    confirm_delete: 'Delete item?',
    copied: 'Copied',
    statusProcessingShort: 'In progress',
    success: 'Success',
    aiSommelierTitle: 'Sommelier',
    noOrders: 'No active orders',
    noOrdersText: 'Your active orders will appear here',
    activeOrder: 'Active Order',
    myOrders: 'My Orders',
    authSuccess: 'Account created!',
    statusAccepted: 'Accepted',
    statusProcessing: 'Preparing',
    statusOnWay: 'On the way / Ready for pickup',
    statusCompleted: 'Completed',
    statusRejected: 'Cancelled',
    historyAuthTitle: 'Order History',
    historyAuthDesc: 'Sign in or register to view your order history.',
    login: 'Sign In',
    register: 'Register',
    or: 'or',
    loginWithGoogle: 'Sign in with Google',
    noAccount: "Don't have an account? Sign up",
    hasAccount: 'Already have an account? Sign in',
    orderHistory: 'Order History',
    emptyHistory: 'You have not placed any orders yet',
    date: 'Date',
    type: 'Type',
    deliveryType: 'Delivery',
    pickupType: 'Takeaway',
    callWaiter: 'Call Waiter',
    howCanWeHelp: 'How can we help?',
    billCard: 'Bill (Card)',
    billCash: 'Bill (Cash)',
    requestSent: 'Request Sent!',
    waiterNavigating: 'The waiter is on the way to you.',
    scans: 'Sessions',
    noDataForPeriod: 'No data for this period',
    total: 'Total',
    last7Days: 'Last 7 days',
    last30Days: 'Last 30 days',
    executiveSummary: 'Executive Summary',
    visitors: 'Visitors',
    trafficVolume: 'Traffic Volume',
    expand: 'Expand',
    collapse: 'Collapse',
    deleted: 'Deleted',
    deleteConfirmTitle: 'Confirm Delete',
    categoryName: 'Category Name',
    noSection: 'Uncategorized',
    categoryDescriptionLabel: 'Description (e.g. meat dishes)',
    sectionName: 'Section Name',
    sectionsEmpty: 'Sections are empty',
    addBanner: 'Add Banner',
    editBanner: 'Edit Banner',
    fileTooLarge: 'File is too large (max 5MB)',
    errorSending: 'Error sending: ',
    qrStyleSquare: 'Square',
    qrStyleRounded: 'Rounded',
    qrStyleDots: 'Dots',
    qrStyleClassy: 'Classy',
    qrStyleClassyRounded: 'Classy (round.)',
    qrStyleExtraRounded: 'Extra rounded',
    qrStyleDot: 'Dot',
    'qrColor.pattern': 'Pattern',
    'qrColor.background': 'Background',
    'qrColor.eyeFrame': 'Eye Frame',
    'qrColor.eyeDot': 'Eye Dot',
    qrColorFrame: 'Frame',
    qrColorText: 'Text',
    mon: 'Mon',
    tue: 'Tue',
    wed: 'Wed',
    thu: 'Thu',
    fri: 'Fri',
    sat: 'Sat',
    sun: 'Sun',
    everyDay: 'Every day',
    weekdays: 'Weekdays',
    weekend: 'Weekend',
    isClosed: 'Closed',
    open24h: '24/7',
    variant: 'Variant',
    in_hall: 'In hall',
    scan: 'Scan',
    availableMsg: 'Available',
    unavailableMsg: 'Unavailable',
    checkout: 'Checkout',
    contacts: 'Contacts',
    yourNamePlaceholder: 'How should we address you?',
    whereToDeliver: 'Where to deliver?',
    addressPlaceholder: 'Street, house, apartment',
    sendOrder: 'Place Order',
    enterNameAlert: 'Please provide your name.',
    enterPhoneAlert: 'Please enter a valid complete phone number.',
    enterAddressAlert: 'Please provide the delivery address.',

    // Characteristics & Pills
    pill_wine_red: 'Red',
    pill_wine_red_desc: 'Red wine - made from dark grape varieties with rich berry notes and tannins.',
    pill_wine_white: 'White',
    pill_wine_white_desc: 'White wine - light and crisp, made from white grapes or clear grape juice.',
    pill_wine_rose: 'Rosé',
    pill_wine_rose_desc: 'Rosé wine - fresh and aromatic, produced with brief grape skin contact.',
    pill_wine_dry: 'Dry',
    pill_wine_dry_desc: 'Dry wine - residual sugar up to 4 g/l with crisp natural acidity.',
    pill_wine_semidry: 'Semi-dry',
    pill_wine_semidry_desc: 'Semi-dry wine - sugar 4-18 g/l, pleasant balance of mild sweetness and freshness.',
    pill_wine_semisweet: 'Semi-sweet',
    pill_wine_semisweet_desc: 'Semi-sweet wine - sugar 18-45 g/l, smooth and noticeably sweet.',
    pill_wine_sweet: 'Sweet',
    pill_wine_sweet_desc: 'Sweet wine - dessert wine with high sugar content (above 45 g/l).',
    pill_wine_brut: 'Brut',
    pill_wine_brut_desc: 'Brut - dry sparkling wine with minimal sugar and elegant bubbles.',

    pill_spirits_singlemalt: 'Single Malt',
    pill_spirits_singlemalt_desc: 'Single Malt - whiskey produced at a single distillery from 100% malted barley.',
    pill_spirits_blended: 'Blended',
    pill_spirits_blended_desc: 'Blended - whiskey made by blending malt and grain spirits for smooth balance.',
    pill_spirits_singlegrain: 'Single Grain',
    pill_spirits_singlegrain_desc: 'Single Grain - whiskey made at a single distillery using wheat, corn or rye.',
    pill_spirits_blendedmalt: 'Blended Malt',
    pill_spirits_blendedmalt_desc: 'Blended Malt - a blend of single malt whiskies from different distilleries.',
    pill_spirits_singlepotstill: 'Single Pot Still',
    pill_spirits_singlepotstill_desc: 'Single Pot Still - traditional Irish whiskey distilled in pot stills from malted and green barley.',

    country_ireland: 'Ireland',
    country_ireland_desc: 'Ireland - birthplace of smooth, triple-distilled whiskey and classic beverage traditions.',
    country_scotland: 'Scotland',
    country_scotland_desc: 'Scotland - homeland of Scotch whisky crafted with centuries-old oak barrel aging.',
    country_france: 'France',
    country_france_desc: 'France - world benchmark for fine winemaking, cognac, and refined aperitifs.',
    country_usa: 'USA',
    country_usa_desc: 'USA / American style - famed for traditional corn bourbon aged in charred new oak barrels.',
    country_american: 'America',
    country_japan: 'Japan',
    country_japan_desc: 'Japan - refined, harmonious distillation style known for precision and craftsmanship.',
    country_japanese: 'Japan',
    country_italy: 'Italy',
    country_italy_desc: 'Italy - home to iconic aperitifs, vermouths, and noble Mediterranean wines.',
    country_spain: 'Spain',
    country_spain_desc: 'Spain - land of vibrant wines, Cava, Sherry, and rich culinary tradition.',
    country_georgia: 'Georgia',
    country_georgia_desc: 'Georgia - cradle of winemaking with an 8,000-year history and traditional Qvevri aging.',
    country_germany: 'Germany',
    country_germany_desc: 'Germany - home of world-class Rieslings celebrated for precision acidity and minerality.',
    country_kazakhstan: 'Kazakhstan',
    country_kazakhstan_desc: 'Kazakhstan - local production crafted with modern standards and quality ingredients.',
    country_chile: 'Chile',
    country_chile_desc: 'Chile - birthplace of world-renowned Carménère and vibrant, fruit-forward wines.',
    country_portugal: 'Portugal',
    country_portugal_desc: 'Portugal - famous for classic Port wines, fresh Vinho Verde, and indigenous varietals.',
    country_mexico: 'Mexico',
    country_mexico_desc: 'Mexico - home to authentic 100% blue agave tequila and artisanal mezcal.',
    country_china: 'China',
    country_china_desc: 'China - ancient beverage heritage and craft distillation traditions.',
    country_korea: 'Korea',
    country_korea_desc: 'Korea - birthplace of smooth soju and classic fermented beverages.',
    country_argentina: 'Argentina',
    country_argentina_desc: 'Argentina - global benchmark for bold Malbec crafted in high-altitude Mendoza vineyards.',
    country_australia: 'Australia',
    country_australia_desc: 'Australia - acclaimed for bold Shiraz and expressive modern winemaking.',
    country_new_zealand: 'New Zealand',
    country_new_zealand_desc: 'New Zealand - benchmark for vibrant Sauvignon Blanc with crisp, tropical aromas.',
    country_austria: 'Austria',
    country_austria_desc: 'Austria - home of mineral Grüner Veltliner and elegant terroir-driven wines.',
    country_greece: 'Greece',
    country_greece_desc: 'Greece - ancient winemaking cradle renowned for Assyrtiko and volcanic terroir.',
    country_czech: 'Czech Republic',
    country_czech_desc: 'Czech Republic - home of classic Pilsner brewing and traditional herbal spirits.',
    country_belgium: 'Belgium',
    country_belgium_desc: 'Belgium - global capital of historic abbey and Trappist craft brewing.',
    country_switzerland: 'Switzerland',
    country_switzerland_desc: 'Switzerland - pristine Alpine terroir crafted with precision and purity.',
    country_netherlands: 'Netherlands',
    country_netherlands_desc: 'Netherlands - birthplace of genever and centuries-old distilling heritage.',
    country_south_africa: 'South Africa',
    country_south_africa_desc: 'South Africa - renowned for distinctive Pinotage and Chenin Blanc from Stellenbosch.',
    country_turkey: 'Turkey',
    country_turkey_desc: 'Turkey - traditional drinks with rich heritage, aromatic fruits, and spices.',
    country_uzbekistan: 'Uzbekistan',
    country_uzbekistan_desc: 'Uzbekistan - sun-drenched terroir with rich traditions of fruit and wine craft.',
    country_armenia: 'Armenia',
    country_armenia_desc: 'Armenia - legendary home of fine aged brandy and ancient Areni grape varieties.',
    country_azerbaijan: 'Azerbaijan',
    country_azerbaijan_desc: 'Azerbaijan - Caspian region celebrated for pomegranate and sun-ripened varietals.',
    countryOfOriginTpl: 'Country of origin: %country%. Authentic drink reflecting regional terroir.',
    drinkFeatureTpl: 'Drink feature: %tag%',
    unsavedChangesTitle: 'Unsaved Changes',
    unsavedChangesMessage: 'You have unsaved changes. Would you like to save them before exiting, or discard them?',
    saveAndClose: 'Save',
    discardAndClose: 'Discard & Close',
    continueEditing: 'Cancel'
};

export default en;
